/**
 * Exports de todos os Steps
 */

import Step0_Inicio from './Step0_Inicio';
import Step1_Cidade from './Step1_Cidade';
import Step2_Nome from './Step2_Nome';
import Step3_Email from './Step3_Email';
import Step4_Whatsapp from './Step4_Whatsapp';
import Step5_DataNascimento from './Step5_DataNascimento';
import Step6_Nacionalidade from './Step6_Nacionalidade';
import Step7_RG from './Step7_RG';
import Step8_CPF from './Step8_CPF';
import Step9_Restricoes from './Step9_Restricoes';
import Step10_Revendedora from './Step10_Revendedora';
import Step11_EstadoCivil from './Step11_EstadoCivil';
import Step12_Endereco from './Step12_Endereco';
import Step13_Residencia from './Step13_Residencia';
import Step14_Filhos from './Step14_Filhos';
import Step15_Emprego from './Step15_Emprego';
import Step16_Renda from './Step16_Renda';
import Step17_Cartao from './Step17_Cartao';
import Step17A_Veiculo from './Step17A_Veiculo';
import Step18_Instagram from './Step18_Instagram';
import Step19_ReferenciaFamiliar1 from './Step19_ReferenciaFamiliar1';
import Step20_ReferenciaFamiliar2 from './Step20_ReferenciaFamiliar2';
import Step21_Mae from './Step21_Mae';
import Step22_Educacao from './Step22_Educacao';
import Step22_RegraFinal from './Step22_RegraFinal';
import Step23_Finalizacao from './Step23_Finalizacao';
import Step9_RestricoesDetalhes from './Step9_RestricoesDetalhes';
import StepAdicional_ObjetivoLucro from './StepAdicional_ObjetivoLucro';
import { Step20A_ReferenciaComercial } from './Step20A_ReferenciaComercial';
import Step20B_MotivacaoEmbaixadora from './Step20B_MotivacaoEmbaixadora';
import Step20C_InteresseXizinha from './Step20C_InteresseXizinha';
import Step20D_AprendizadoApp from './Step20D_AprendizadoApp';
import Step20E_TecnologiaRedes from './Step20E_TecnologiaRedes';
import Step20E1_Entrevista from './Step20E1_Entrevista';
import Step20E2_Treinamento from './Step20E2_Treinamento';
import { Step20F_ContratoResponsabilidade } from './Step20F_ContratoResponsabilidade';
import { Step20G_Duvidas } from './Step20G_Duvidas';

export const STEPS = [
  { id: 'step0_inicio', component: Step0_Inicio, title: 'Início' },
  { id: 'step1_cidade', component: Step1_Cidade, title: 'Cidade' },
  { id: 'step2_nome', component: Step2_Nome, title: 'Nome' },
  { id: 'step3_email', component: Step3_Email, title: 'Email' },
  { id: 'step4_whatsapp', component: Step4_Whatsapp, title: 'WhatsApp' },
  { id: 'step5_nascimento', component: Step5_DataNascimento, title: 'Nascimento' },
  { id: 'step6_nacionalidade', component: Step6_Nacionalidade, title: 'Nacionalidade' },
  { id: 'step7_rg', component: Step7_RG, title: 'RG' }, 
  { id: 'step8_cpf', component: Step8_CPF, title: 'CPF' },
  { id: 'step9_restricoes', component: Step9_Restricoes, title: 'Restrições' },
  { id: 'step21_mae', component: Step21_Mae, title: 'Mãe' },
  { id: 'step9_restricoes_detalhes', component: Step9_RestricoesDetalhes, title: 'Restrições' },
  { id: 'step10_revendedora', component: Step10_Revendedora, title: 'Revendedora' },
  { id: 'step11_estadocivil', component: Step11_EstadoCivil, title: 'Estado Civil' },
  { id: 'step22_educacao', component: Step22_Educacao, title: 'Educação' },
  { id: 'step12_endereco', component: Step12_Endereco, title: 'Endereço' },
  { id: 'step13_residencia', component: Step13_Residencia, title: 'Residência' },
  { id: 'step14_filhos', component: Step14_Filhos, title: 'Filhos' },
  { id: 'step15_emprego', component: Step15_Emprego, title: 'Emprego' },
  { id: 'step16_renda', component: Step16_Renda, title: 'Renda' },
  { id: 'step_adicional_objetivo_lucro', component: StepAdicional_ObjetivoLucro, title: 'Objetivo Lucro' },
  { id: 'step17_cartao', component: Step17_Cartao, title: 'Cartão' },
  { id: 'step17A_veiculo', component: Step17A_Veiculo, title: 'Veículo' },
  { id: 'step18_instagram', component: Step18_Instagram, title: 'Instagram' },
  { id: 'step19_ref_familar_1', component: Step19_ReferenciaFamiliar1, title: 'Ref. Familiar 1' },
  { id: 'step20_ref_familiar_2', component: Step20_ReferenciaFamiliar2, title: 'Ref. Familiar 2' },
  { id: 'step20A_ref_comercial', component: Step20A_ReferenciaComercial, title: 'Ref. Comercial' },
  { id: 'step20B_motivacao_embaixadora', component: Step20B_MotivacaoEmbaixadora, title: 'Motivação Embaixadora' },
  { id: 'step20C_interesse_xizinha', component: Step20C_InteresseXizinha, title: 'Interesse Xizinha' },
  { id: 'step20D_aprendizado_app', component: Step20D_AprendizadoApp, title: 'Aprendizado App' },
  { id: 'step20E_tecnologia_redes', component: Step20E_TecnologiaRedes, title: 'Tecnologia e Redes' },
  { id: 'step20E1_entrevista', component: Step20E1_Entrevista, title: 'Entrevista Online' },
  { id: 'step20E2_treinamento', component: Step20E2_Treinamento, title: 'Treinamento Vendas' },
  { id: 'step20F_contrato_responsabilidade', component: Step20F_ContratoResponsabilidade, title: 'Contrato Responsabilidade' },
  { id: 'step20G_duvidas', component: Step20G_Duvidas, title: 'Dúvidas' },
  { id: 'step22_regra_final', component: Step22_RegraFinal, title: 'Regra Final' },
  { id: 'step23_finalizacao', component: Step23_Finalizacao, title: 'Finalização' },
];

export default STEPS;
